import axios from 'axios'
import store from '../store'

// It's bad practice to include interceptors on every axios request, so we create an
// additional instance we can use when we want to invoke our interceptors
const submit = axios.create()

submit.interceptors.request.use(request => {
  store.commit('axiosError', null)
  return request
})

submit.interceptors.response.use(response => {
  return response
}, error => {
  store.commit('axiosError', error)
  store.commit('submitting', false)
  return Promise.reject(error)
})

export default submit
